// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__hKJ9x","actionsCol":"EnrolledClinics_actionsCol__2ESb3"};